import { render } from "./CardExpansion.vue?vue&type=template&id=4e4b92fa&ts=true"
import script from "./CardExpansion.vue?vue&type=script&lang=ts"
export * from "./CardExpansion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__